export const pollJob = async (api, jobId, { interval = 3000, timeout = 300000 } = {}) => {
  const end = Date.now() + timeout;
  while (Date.now() < end) {
    await new Promise((r) => setTimeout(r, interval));
    const { data } = await api.get(`/ai-jobs/${jobId}`);
    if (data.status === 'completed') return data.result;
    if (data.status === 'failed') throw new Error(data.error || 'La tarea falló');
  }
  throw new Error('La tarea tardó demasiado. Intenta nuevamente.');
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
